import { useState } from 'react';
import { Link } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import logo from '../../assets/logoMoovicar.png';
import { useAxios } from '../../utils/hook/useAxios';

function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const axios = useAxios();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!/^\S+@\S+\.\S+$/.test(email)) {
      toast.error('Adresse email invalide');
      return;
    }
    setLoading(true);
    try {
      await axios.post('/auth/forgot-password', { email: email });
      setSent(true);
    } catch {
      toast.error('Une erreur est survenue. Réessayez.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="min-vh-100 d-flex flex-column align-items-center justify-content-center bg-body-tertiary py-4">
      <ToastContainer position="top-center" />

      <div style={{ width: '100%', maxWidth: 420, padding: '0 1rem' }}>
        {/* Logo */}
        <div className="text-center mb-4">
          <Link to="/">
            <img src={logo} alt="Moovicar" height="48" />
          </Link>
        </div>

        {/* Card */}
        <div className="card border-0 shadow-sm rounded-4 p-4">
          {sent ? (
            /* État : email envoyé */
            <div className="text-center py-2">
              <div
                className="d-inline-flex align-items-center justify-content-center rounded-circle bg-success-subtle mb-3"
                style={{ width: 64, height: 64 }}
              >
                <i className="bi bi-envelope-check-fill text-success" style={{ fontSize: 28 }}></i>
              </div>
              <h5 className="fw-bold mb-2">Email envoyé !</h5>
              <p className="text-muted mb-4" style={{ fontSize: 14 }}>
                Si l'adresse <strong>{email}</strong> est associée à un compte, vous recevrez un
                lien de réinitialisation dans quelques minutes.
              </p>
              <p className="text-muted mb-3" style={{ fontSize: 13 }}>
                Pensez à vérifier vos spams.
              </p>
              <button
                className="btn btn-outline-secondary w-100 rounded-3"
                onClick={() => {
                  setSent(false);
                  setEmail('');
                }}
              >
                Renvoyer un lien
              </button>
            </div>
          ) : (
            /* État : formulaire */
            <>
              <div className="text-center mb-4">
                <div
                  className="d-inline-flex align-items-center justify-content-center rounded-circle bg-primary-subtle mb-3"
                  style={{ width: 56, height: 56 }}
                >
                  <i className="bi bi-lock-fill text-primary" style={{ fontSize: 24 }}></i>
                </div>
                <h4 className="fw-bold mb-1">Mot de passe oublié ?</h4>
                <p className="text-muted mb-0" style={{ fontSize: 14 }}>
                  Entrez votre email pour recevoir un lien de réinitialisation.
                </p>
              </div>

              <form onSubmit={handleSubmit}>
                <div className="mb-4">
                  <label className="form-label small fw-semibold text-muted">Adresse email</label>
                  <input
                    type="email"
                    className="form-control rounded-3"
                    placeholder="votre@email.com"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    autoComplete="email"
                    required
                  />
                </div>

                <button
                  type="submit"
                  className="btn btn-primary w-100 rounded-3 py-2 fw-semibold"
                  disabled={loading || !email}
                >
                  {loading ? (
                    <>
                      <span className="spinner-border spinner-border-sm me-2" />
                      Envoi…
                    </>
                  ) : (
                    <>
                      <i className="bi bi-send me-2"></i>Envoyer le lien
                    </>
                  )}
                </button>
              </form>
            </>
          )}
        </div>

        {/* Retour connexion */}
        <p className="text-center text-muted mt-3" style={{ fontSize: 14 }}>
          <Link to="/signin" className="text-muted text-decoration-none">
            <i className="bi bi-arrow-left me-1"></i>Retour à la connexion
          </Link>
        </p>
      </div>
    </section>
  );
}

export default ForgotPassword;
